import React, { useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import PageHeader from "../components/ui/PageHeader";
import ProjectList from "../components/projects/ProjectList";
import ProjectForm from "../components/projects/ProjectForm";
import ProjectDetail from "../components/projects/ProjectDetail";
import { Box, Button, Dialog, DialogContent, useTheme } from "@mui/material";
import { Add } from "@mui/icons-material";

const ProjectsPage = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const [showForm, setShowForm] = useState(false);
  const [editingProject, setEditingProject] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get("new") === "true") {
      setShowForm(true);
    }
  }, []);
  const handleView = (project) => {
    navigate(`/projects/${project.id}`);
  };

  const handleEdit = (project) => {
    setEditingProject(project);
    setShowForm(true);
  };

  const handleSave = () => {
    setShowForm(false);
    setEditingProject(null);
    setRefreshKey((k) => k + 1);
  };

  if (projectId) {
    return <ProjectDetail projectId={projectId} onEdit={handleEdit} />;
  }

  return (
    <Box>
      <PageHeader
        title="Proyectos"
        action={
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => {
              setEditingProject(null);
              setShowForm(true);
            }}
            sx={{
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
              boxShadow: 'none',
              '&:hover': {
                boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
                filter: 'brightness(1.05)',
              },
            }}
          >
            Nuevo Proyecto
          </Button>
        }
      />
      <ProjectList key={refreshKey} onView={handleView} onEdit={handleEdit} />

      <Dialog
        key={editingProject?.id || "new"}
        open={showForm}
        onClose={() => {
          setShowForm(false);
          setEditingProject(null);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
            maxHeight: "90vh",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <ProjectForm
            project={editingProject}
            onSave={handleSave}
            onCancel={() => {
              setShowForm(false);
              setEditingProject(null);
            }}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ProjectsPage;